import React, {PropTypes} from 'react';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import {HEADER_ONE_ICONS, headerOneIconFactory} from './icons/index';
import ArrowIcon from 'material-ui/svg-icons/navigation/arrow-drop-down-circle'

export class SelectIcon extends React.Component {
  static propTypes = {
    color: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    color: 'black'
  };

  render() {
    const {value, color, onChange} = this.props;

    return (
      <IconMenu
        iconButtonElement={<IconButton>{value ? React.createElement(headerOneIconFactory(value), {color}) : <ArrowIcon />}</IconButton>}
        value={value}
        onChange={(event, val) => onChange(val)}
      >
        {HEADER_ONE_ICONS.map((icon, index) => <MenuItem
          key={index}
          value={icon}
          leftIcon={React.createElement(headerOneIconFactory(icon))}
        />)}
      </IconMenu>
    );
  }
}

export default SelectIcon;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/HeaderOne/SelectIcon.js